<template>

    <div v-if="edits && edits.length" class="message-edits">

        <!-- Toggle -->
        <div class="text-right">
            <small class="message-edits-toggle text-muted" v-on:click="open = !open">{{ $t('simple.edited') }}</small>
        </div>

        <!-- Earlier texts, oldest first, with the attachments each edit replaced -->
        <template v-if="open">
            <div v-for="edit in edits" :key="edit.id" class="message-edits-item">
                <span class="message-content" :class="lang === 'AR' ? 'text-right' : ''" :dir="lang === 'AR' ? 'rtl' : 'ltr'">{{ edit.content }}</span>
                <small :id="'question-edit-' + edit.id" class="text-muted text-nowrap">({{ $t('simple.edited_ago', { time: $moment.utc(edit.edited_at).fromNow() }) }})</small>

                <b-popover :target="'question-edit-' + edit.id" triggers="hover" placement="top">
                    {{ $moment($moment.utc(edit.edited_at)).local().format('YYYY-MM-DD HH:mm:ss') }}
                </b-popover>

                <message-attachments v-if="edit.attachments && edit.attachments.length" v-bind:attachments="edit.attachments"></message-attachments>
            </div>
        </template>

    </div>

</template>

<script>

    export default {

        props: ['edits', 'lang'],

        data: function() { return {
            open: false,
        } },

    }

</script>

<style scoped>

    .message-edits-toggle {
        cursor: pointer;
    }

    .message-edits-item {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        margin-top: 0.5rem;
        padding-top: 0.5rem;
    }

</style>
